import { ServiceMaker, methods, services } from "@/services";

export const createTemplateSms = payload =>
  ServiceMaker(
    `/communication/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateSms = payload =>
  ServiceMaker(
    `/communication/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchSmsTemplateAll = (payload) =>
  ServiceMaker(
    `/communication/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );
